module.exports = __webpack_public_path__ + "img/img_sub_ser_Integration01.d9aa6be8.svg";